import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { AboutDialogComponent } from '../../shared/components/about-dialog/about-dialog.component';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class NavComponent implements OnInit,AfterViewInit,  OnDestroy {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private dialog = inject(MatDialog);


  isAuthenticated = false;
  userFullName = "";
  collapsed = true;
  public user:User = null;
  private userSub: Subscription

  ngOnInit(): void {

   this.userSub = this._authService.user.subscribe(user =>
    {
      this.isAuthenticated = !user ? false : true;

      this.user = user;


      this.userFullName = !user ? "" : user.userFullName.trim().length > 0 ? user.userFullName : "Unknown User";

    });
  }

  ngAfterViewInit(): void
  {

  }



  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }

  openAbout()
  {
    this.dialog.open(AboutDialogComponent,{width:'30%'}).afterClosed().subscribe(result => {});
  }




  logout()
  {
    this._router.navigate(["login"]);
    this._authService.logout();

  }





}
